export const DealBuilderProductSearch = `query products($id: String!) {
    products(filter: { sku: { eq: $id } }) {
      total_count
      items {
        id
        name
        deal_builder_deals
        contract_sku
        stock_status
        stock_message {
          out_of_stock_title
          out_of_stock_description
          low_stock_title
          low_stock_description
        }
        sku
        delivery_message
        image {
          url
          label
        }
        small_image {
          url
          label
        }
        media_gallery {
          url
          label
        }
        ... on ConfigurableProduct {
          configurable_options {
            label
            attribute_code
           attribute_id
            values {
              value_index
              label
              swatch_data {
                value
              }
            }
          }
          variants {
            product {
              id
              name
              sku
              quantity
              stock_message {
                  out_of_stock_title
                  out_of_stock_description
              }
              stock_status
              image {
                url
                label
              }
              small_image {
                url
                label
              }
              thumbnail {
                url
                label
              }
              media_gallery {
                url
                label
              }
            }
            attributes {
              label
              code
              value_index,
            }
          }
        }
      }
    }
  }
  `;

export const DealBuilderRecommendedPlans = `query products($filter: ProductAttributeFilterInput, $pageSize: Int) {
    products(
       filter: $filter,
       pageSize: $pageSize,
       sort: {
           monthly_recurring: ASC
       }
    ) {
        total_count
        page_info {
            page_size
            current_page
            total_pages
        }
        items {
           name
           sku
           promo_data
           minutes
           contract_type
           contract_type_label
           promotion_tag_swatch
           minutes_label
           airtime
           sms
           primary_product_sku
           contract_sku
           payment_terms
           payment_terms_label
           package_description
           promotion_tag
           promotion_tag_label
           plan_type
           plan_type_label
           plan_name
           plan_name_label
           monthly_recurring
           old_tariff
           old_installment
           old_monthly_recurring
           nightowl_units
           nightowl_uom
           save_monthly_recurring
           stock_status
           deal_go_live_date
           deal_end_date
           deal_label
           ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } }
           ... on BundleProduct {
              enable_click_and_collect
              items {
                  option_id
                  title
                  required
                  type
                  position
                  sku
                  options {
                      id
                      quantity
                      position
                      is_default
                      price
                      price_type
                      is_hidden_product
                      can_change_quantity
                      label
                      product {
                        id
                        name
                        sku
                        monthly_recurring
                        old_tariff
                        old_installment
                        old_monthly_recurring
                        quantity
                        stock_status
                        promotion_link
                        primary_product_sku
                        promo_data
                        nightowl_units
                        nightowl_uom
                        minutes
                        minutes_label
                        airtime
                        sms
                        badges
                        visibility
                        attribute_set_id
                        badges_label
                        promotion_tag_swatch
                        badges_swatch
                        color
                        color_label
                        size
                        size_label
                        screen_size_pixels_label
                        internal_storage
                        internal_storage_label
                        battery_capacity_label
                        __typename
                        image {
                          url
                          label
                        }
                        small_image {
                          url
                          label
                        }
                        ... on ConfigurableProduct {
                          configurable_options {
                          label
                          attribute_code
                               attribute_id
                          values {
                            value_index
                            label
                            swatch_data {
                            value
                            }
                          }
                          }
                          variants {
                          product {
                            id
                            name
                            contract_sku
                            sku
                            stock_message {
                              out_of_stock_title
                              out_of_stock_description
                            }
                            delivery_and_return
                            stock_status
                            image {
                            url
                            label
                            }
                            small_image {
                            url
                            label
                            }
                            thumbnail {
                            url
                            label
                            }
                            media_gallery {
                            url
                            label
                            }
                          }
                          attributes {
                            label
                            code
                            value_index,
                          }
                          }
                        }
                      }
                  }
              }
           }
        }
    }
}`;

export const DealBuilderRecommendedPlansBasicInfo = `query products($filter: ProductAttributeFilterInput, $pageSize: Int) {
    products(
       filter: $filter,
       pageSize: $pageSize,
       sort: {
           monthly_recurring: ASC
       }
    ) {
        total_count
        page_info {
            page_size
            current_page
            total_pages
        }
        items {
           name
           sku
           promo_data
           minutes
           contract_type
           contract_type_label
           promotion_tag_swatch
           minutes_label
           airtime
           sms
           primary_product_sku
           contract_sku
           payment_terms
           payment_terms_label
           package_description
           promotion_tag
           promotion_tag_label
           plan_type
           plan_type_label
           plan_name
           plan_name_label
           monthly_recurring
           old_tariff
           old_installment
           old_monthly_recurring
           nightowl_units
           nightowl_uom
           save_monthly_recurring
           stock_status
           deal_go_live_date
           deal_end_date
           deal_label
           ... on BundleProduct {
              items {
                  title
                  options {
                      product {
                        promo_data
                      }
                  }
              }
           }
        }
    }
}`;

export const DealBuilderContractSearch = `query products($name: String)
{
	DealSelection (sku: $name)
	{
	deal_skus
	}
}`;

export const DealBuilderSearchProducts =  `query products(
    $search: String
) {
	products(
        search: $search
        filter: {
            price: {
                from: 0.00,
                to: 9999999999
            },
            is_deal_product: {
                eq: 0
            }
        }
		sort: {
            product_ranking: DESC,
            sku: ASC
        }
        pageSize: 30
        currentPage: 1
	) {

		items {
			name
            sku
            attribute_set_id
		}
	}
}
`;

export const DealBuilderProductData = `query products($id: String!) {
	products(filter: { sku: { eq: $id } }) {
	  items {
	  url_key
		id
		name
		deal_builder_deals
    manufacturer
    manufacturer_label
		contract_sku
		stock_status
		stock_message {
		  out_of_stock_title
		  out_of_stock_description
		  low_stock_title
		  low_stock_description
		}
		sku
		delivery_message
		image {
		  url
		  label
		}
		small_image {
		  url
		  label
		}
		media_gallery {
		  url
		  label
		}
		... on ConfigurableProduct {
		  configurable_options {
			label
			attribute_code
			     attribute_id
			values {
			  value_index
			  label
			  swatch_data {
				value
			  }
			}
		  }
		  variants {
			product {
			  id
			  name
			  contract_sku
			  sku
			  quantity
			  stock_message {
				  out_of_stock_title
				  out_of_stock_description
			  }
			  delivery_and_return
			  stock_status
			  image {
				url
				label
			  }
			  small_image {
				url
				label
			  }
			  thumbnail {
				url
				label
			  }
			  media_gallery {
				url
				label
			  }
			  __typename
			}
			attributes {
			  label
			  code
			  value_index,
			}
		  }
		}
	  }
	}
  }
  `;


export const CmsBlocks = `query blocks($identifiers: [String]) {
  cmsBlocks(identifiers: $identifiers) {
    items {
      identifier
      title
      content
    }
  }
}
`;

export const DealBuilderContractSearchData = `query products($filter: ProductAttributeFilterInput) {
  products(
	 filter: $filter,
	 pageSize: 1000,
	 currentPage: 1,
	 sort: {
		 monthly_recurring: ASC
	 }
  ) {
	  total_count
	  page_info {
		  page_size
		  current_page
		  total_pages
	  }
	  items {
		 name
		 sku
		 promo_data
		 minutes
		 contract_type
		 contract_type_label
		 promotion_tag_swatch
		 minutes_label
		 airtime
		 sms
		 primary_product_sku
		 contract_sku
		 payment_terms
		 payment_terms_label
		 package_description
		 promotion_tag
		 promotion_tag_label
		 plan_type
		 plan_type_label
     plan_name
     plan_name_label
		 monthly_recurring
		 old_tariff
		 old_installment
		 old_monthly_recurring
		 save_monthly_recurring
		 stock_status
		 deal_go_live_date
		 deal_end_date
		 deal_label
		 is_deal_locked
		 __typename
		 image {
		   url
		 }
		 small_image {
		   url
		 }
	   }
	  aggregations {
		 attribute_code
		 options {
		   label
		   value
		 }
	  }
	  price_range {
		 attribute_code
		 min_value
		 max_value
	   }
  }
}`;
